import React from 'react';
import { Icon } from '@fasstech/middle-design-system';
import {
  compose,
  filter,
  find,
  includes,
  map,
  propEq,
  propOr,
  when
} from 'ramda';
import { isNilOrEmpty, mapIndexed } from '../../../../server/helpers/index.mjs';
import { roundPrice } from '../../../_common/server/helpers/groupHealthPricing/roundPrice.mjs';
import classNames from 'classnames';

const Options = ({
  getMiddleText,
  displayedPricings,
  options,
  selectedTariffStructure,
  isSelected,
  selectedOptions,
  toggleOption,
  effectDate
}) => {
  return (
    <div
      className={'grid border rounded-xl shadow-lg w-full'}
      style={{
        gridTemplateColumns: `300px repeat(${displayedPricings.length}, minmax(150px, 1fr))`
      }}
    >
      <div
        className={
          'col-span-full flex font-bold p-4 sticky top-0 z-20 bg-white'
        }
      >
        <span className={'sticky left-0'}>
          {getMiddleText('NIVEAUXGARANTIESETTARIFS_OPTIONS_LABEL')}
        </span>
      </div>

      {isNilOrEmpty(options) && (
        <div className="col-span-full p-8 text-center text-gray-500">
          Aucune option disponible pour les niveaux affichés
        </div>
      )}

      {map((option) => (
        <div key={option.value} className={'contents'}>
          <div className={'ml-4 p-4 font-bold sticky left-0 z-10 bg-white'}>
            <div className={'p-2'}>{option.label}</div>
            <div className={'flex items-center gap-4'}>
              {/* <Icon name="circleDownload" size={30} />
              <div>
                {getMiddleText(
                  'NIVEAUXGARANTIESETTARIFS_OPTIONS_TABLEAU_GARANTIE_LABEL'
                )}
              </div> */}
            </div>
          </div>
          {mapIndexed(
            (
              { pricingLabel, options, optionsSelectionMode, isConformCCN },
              index
            ) => {
              const filteredDetails =
                when(
                  () => pricingLabel !== 'Minimum CCN',
                  compose(
                    filter(
                      propEq('priceYear', String(effectDate.getFullYear()))
                    ),
                    propOr([], 'details'),
                    find(
                      propEq('tariffStructureCode', selectedTariffStructure)
                    ),
                    propOr([], 'prices'),
                    find(propEq('optionCode', option.value))
                  )
                )(options) || [];
              const isLast = index === displayedPricings.length - 1;
              const isOptionSelected = includes(
                option.value,
                propOr([], pricingLabel, selectedOptions)
              );
              const pricingSelected = isSelected(pricingLabel);
              const isDisabled = filteredDetails.length === 0 || !isConformCCN;
              return (
                <div
                  key={pricingLabel + option.value}
                  className={classNames(
                    'flex flex-col items-center justify-start mx-1',
                    {
                      'border-r border-l': !isLast,
                      'border-l': isLast,
                      'cursor-not-allowed': isDisabled || !pricingSelected,
                      'cursor-pointer': !isDisabled && pricingSelected
                    }
                  )}
                  onClick={() => {
                    if (pricingSelected) {
                      toggleOption(
                        pricingLabel,
                        option.value,
                        optionsSelectionMode
                      );
                    }
                  }}
                  data-testid={`${pricingLabel}-${option.value}`}
                >
                  {filteredDetails.length > 0 && (
                    <div className="relative flex flex-col items-center w-4/5 my-4">
                      {filteredDetails.some((d) => d.isRecommended) && (
                        <div className="flex flex-col items-center mb-2">
                          <Icon name="fiveStars" />
                          <span className="text-primary text-[12px] font-bold">
                            RECOMMANDÉ
                          </span>
                        </div>
                      )}

                      <div
                        className={classNames(
                          'border rounded-lg w-full p-2 border-primary-300',
                          {
                            'opacity-50': isDisabled,
                            'bg-white text-primary':
                              !isOptionSelected || !pricingSelected,
                            'bg-primary-300':
                              pricingSelected && isOptionSelected,
                            'text-white': pricingSelected && isOptionSelected
                          }
                        )}
                      >
                        {mapIndexed(
                          ({ label, priceValue, priceUnit }, index) => (
                            <div
                              key={index}
                              className="mb-2 w-full text-center"
                            >
                              <div>{label}</div>
                              <div>
                                <span className={'font-bold text-xl'}>
                                  {roundPrice(priceValue)} {priceUnit}
                                </span>
                                {' / mois'}
                              </div>
                            </div>
                          )
                        )(filteredDetails)}
                      </div>
                    </div>
                  )}
                </div>
              );
            },
            displayedPricings
          )}
        </div>
      ))(options)}
    </div>
  );
};

export default Options;
